/**
 * Azione principale della card (Invia). Nella direzione 03 porta la stessa sfumatura
 * della fascia, rosa #F6D8E0 -> azzurro #BFD7EE a 135°, con testo ink #2B2D31.
 * In alto contrasto diventa blu pieno con testo bianco (direzione 04).
 */
import type { ButtonHTMLAttributes, ReactNode } from 'react'

export type PrimaryButtonProps = Omit<ButtonHTMLAttributes<HTMLButtonElement>, 'className'> & {
  children: ReactNode
}

export function PrimaryButton({ children, type = 'button', ...rest }: PrimaryButtonProps) {
  return (
    <button
      type={type}
      data-component="primary-button"
      className="bg-primary motion-colors mt-4 flex min-h-send w-full items-center justify-center rounded-control px-5 py-2 text-button font-semibold text-primary-text active:scale-[0.99] disabled:cursor-not-allowed disabled:opacity-60"
      {...rest}
    >
      {children}
    </button>
  )
}
